"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckRestaurantServiceAvailability = void 0;
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const useClient_1 = require("../../../../hooks/useClient");
const ErrorResolver_1 = require("../../../../contexts/ErrorResolver");
const SalesOrderContext_1 = require("../contexts/SalesOrderContext");
const currentUnixTimestamp_1 = require("../../../../apis/spg/util/currentUnixTimestamp");
const useCheckRestaurantServiceAvailability = () => {
    const client = (0, useClient_1.useClient)();
    const { resolveError } = (0, useRequiredContext_1.useRequiredContext)(ErrorResolver_1.ErrorResolverContext);
    const { setRequestedReadyTime } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    return async (restaurant, currentOrderType, location, requestedReadyTime, setServiceUnavailableMsg, setCheckingAvailability) => {
        setCheckingAvailability(true);
        const currentTimestamp = (0, currentUnixTimestamp_1.currentUnixTimestamp)();
        const { openingTime } = restaurant.getOperatingDetailsForTime(currentTimestamp);
        const checkRequestedReadyTime = requestedReadyTime < openingTime ? openingTime : requestedReadyTime;
        const latLang = { lat: location.lat, lng: location.lng };
        try {
            const canServiceOrder = await client.retailLocations.checkCanServiceOrder(restaurant.retailLocationId, currentOrderType, checkRequestedReadyTime, latLang);
            setCheckingAvailability(false);
            if (!canServiceOrder.available) {
                setServiceUnavailableMsg(canServiceOrder.message);
                return false;
            }
            setRequestedReadyTime(checkRequestedReadyTime);
            return true;
        }
        catch (e) {
            resolveError({
                title: "Unable to check restaurant service availability",
                approach: "modal"
            });
            return false;
        }
    };
};
exports.useCheckRestaurantServiceAvailability = useCheckRestaurantServiceAvailability;
//# sourceMappingURL=useCheckRestaurantServiceAvailability.js.map